import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface LocaleBrand {
    readonly Locale: unique symbol;
}
export const Locale = brand(NonEmptyString, (n): n is Branded<NonEmptyString, LocaleBrand> => true, 'Locale');
export type Locale = TypeOf<typeof Locale>;
